// import React, { useState } from "react";

// function App() {
//   const [requestId, setRequestId] = useState("");
//   const [apiData, setApiData] = useState(null);
//   const [audioUrl, setAudioUrl] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const fetchAudio = async () => {
//     if (!requestId.trim()) {
//       alert("Please enter a request ID.");
//       return;
//     }

//     setLoading(true);
//     setApiData(null);
//     setAudioUrl(null);

//     const apiEndpoint = `https://zzwvbuapsk.execute-api.ap-south-1.amazonaws.com/default/getfroms3_video_otp_blob?request_id=${requestId}`;

//     try {
//       const response = await fetch(apiEndpoint);
//       const data = await response.json();
//       setApiData(data);

//       if (data.audio_base64 && data.content_type) {
//         const blob = base64ToBlob(data.audio_base64, data.content_type);
//         const url = URL.createObjectURL(blob);
//         setAudioUrl(url);
//       }
//     } catch (err) {
//       console.error("Failed to fetch audio:", err);
//       alert("Error fetching audio. Check console for details.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const base64ToBlob = (base64, mime) => {
//     const byteChars = atob(base64);
//     const byteNums = new Array(byteChars.length);
//     for (let i = 0; i < byteChars.length; i++) {
//       byteNums[i] = byteChars.charCodeAt(i);
//     }
//     return new Blob([new Uint8Array(byteNums)], { type: mime });
//   };

//   return (
//     <div style={styles.container}>
//       <h2 style={styles.title}>🎧 Video OTP Audio Fetcher</h2>

//       <div style={styles.inputGroup}>
//         <input
//           style={styles.input}
//           type="text"
//           placeholder="Enter Request ID"
//           value={requestId}
//           onChange={(e) => setRequestId(e.target.value)}
//         />
//         <button style={styles.button} onClick={fetchAudio} disabled={loading}>
//           {loading ? "Loading..." : "Fetch Audio"}
//         </button>
//       </div>

//       {/* {apiData && (
//         <div style={styles.responseBox}>
//           <h4>📦 API Response:</h4>
//           <pre style={styles.pre}>{JSON.stringify(apiData, null, 2)}</pre>
//         </div>
//       )} */}

//       {audioUrl && (
//         <div style={{ marginTop: "20px" }}>
//           <h4>🔊 Audio Player:</h4>
//           <audio controls src={audioUrl} style={styles.audioPlayer} />
//         </div>
//       )}
//     </div>
//   );
// }

// const styles = {
//   container: {
//     padding: "30px",
//     fontFamily: "Segoe UI, sans-serif",
//     maxWidth: "700px",
//     margin: "0 auto",
//     backgroundColor: "#fdfdfd",
//     borderRadius: "8px",
//     boxShadow: "0 0 10px rgba(0,0,0,0.1)",
//   },
//   title: {
//     marginBottom: "20px",
//     color: "#333",
//     textAlign: "center",
//   },
//   inputGroup: {
//     display: "flex",
//     gap: "10px",
//     marginBottom: "20px",
//   },
//   input: {
//     flex: 1,
//     padding: "10px",
//     fontSize: "16px",
//     border: "1px solid #ccc",
//     borderRadius: "4px",
//   },
//   button: {
//     padding: "10px 20px",
//     fontSize: "16px",
//     backgroundColor: "#007bff",
//     color: "white",
//     border: "none",
//     borderRadius: "4px",
//     cursor: "pointer",
//   },
//   responseBox: {
//     marginTop: "20px",
//     backgroundColor: "#f1f1f1",
//     padding: "15px",
//     borderRadius: "6px",
//     fontSize: "14px",
//   },
//   pre: {
//     whiteSpace: "pre-wrap",
//     wordBreak: "break-word",
//     fontFamily: "Courier New, monospace",
//   },
//   audioPlayer: {
//     width: "100%",
//     marginTop: "10px",
//   },
// };

// export default App;


import React, { useEffect } from "react";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import BotTabs from "./Components/BotTabs";
import Agent from "./Agent";
import AdharOCR from "./Components/AdharOCR";
import PanOCR from "./Components/PanOCR";
import Login from "./Components/Login";
import Logout from "./Components/Logout";
import DigilockerRe from "./Components/DigilockerRe";
import Download from "./Components/Download";
import EsigneDownload from "./Components/Esigned"
import CDSLData from "./Components/CDSLData";
import SignSdkCheck from "./Components/signCheck";
import NomineeOptOutSdk from "./Components/NomineeOptOut";
import OvdSDK from "./Components/ovd";
import VipvCheck from "./Components/VipvCheck";

function App() {
  useEffect(() => {
    const handleRightClick = (e) => {
      e.preventDefault();
    };

    const handleDoubleClick = (e) => {
      e.preventDefault();
    };

    window.addEventListener("contextmenu", handleRightClick);
    window.addEventListener("dblclick", handleDoubleClick);

    return () => {
      window.removeEventListener("contextmenu", handleRightClick);
      window.removeEventListener("dblclick", handleDoubleClick);
    };
  }, []);

  const cors = require("cors");
  cors();

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/EsigneDownload" element={<EsigneDownload />} />
        <Route path="/BotTabs" element={<BotTabs />} />
        <Route path="/Agent" element={<Agent />} />
        <Route path="/PanOCR" element={<PanOCR />} />
        <Route path="/AdharOCR" element={<AdharOCR />} />
        <Route path="/Logout" element={<Logout />} />
        <Route path="/DigilockerRe" element={<DigilockerRe />} />
        <Route path="/Download" element={<Download />} />
        <Route path="/CDSLData" element={<CDSLData />} />
        <Route path="/SignSdk" element={<SignSdkCheck />} />
        <Route path="/nomineeOptOut" element={<NomineeOptOutSdk />} />
        <Route path="/OvdSDK" element={<OvdSDK />} />
        <Route path="/VipvCheck" element={<VipvCheck />} />
        <Route path="*" element={<h1>404 Not Found</h1>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;